export default "__VITE_ASSET__a0644083__"